<mat-card-header class="justify-content-center">
  <mat-card-title class="card-title">Add Rewards for your Supporters</mat-card-title>
</mat-card-header>
<hr class="line">
<mat-card-content>
  <mat-card class="mt-30 reward-card" *ngFor="let item of rewards; let i=index" >
    <mat-card-content>
      <div class="reward-card-header">
        <span class="amount">{{ item.amount_usd | currency}}</span>
        <button mat-icon-button (click)="openDialog(deleteRewardDialog, item.id, i)">
          <mat-icon class="icon-delete icon"></mat-icon>
        </button>
      </div>
      <div class="reward-content">
        <span class="r-title">{{item.descp}}</span>
        <span class="r-desc">{{item.notes}}</span>
        <span class="r-other">Estimated Delivery: {{item.expected_date}}</span>
        <span class="r-other">No's: {{item.backers=='-99'?'Unlimited':item.backers}}</span>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card matRipple class="mt-30 add-rewards" (click)="openDialog(rewardDialog)" >
    <mat-card-content class="last-child">
      <div class="add-icon">
        <mat-icon class="icon-plus"></mat-icon>
      </div>
      <div>Add Reward(s)</div>
    </mat-card-content>
  </mat-card>
</mat-card-content>
<mat-card-footer class="fund-button-container">
  <button mat-raised-button class="fund-button" type="button" color="primary" (click)="submitButton()">SUBMIT FOR APPROVAL</button>
</mat-card-footer>

<!-- rewards modal -->
<ng-template #addRewardModal>
  <div matDialogTitle class="dialog-title">Add Reward</div>
  <mat-dialog-content class="mat-dialog-content">
    <form (keydown.enter)="$event.preventDefault()" class="form-container" [formGroup]="rewardForm" (ngSubmit)="submit()">
      <!-- Amount-starts -->
      <div class="amount-container">
        <mat-form-field class="amount-input" appearance="standard">
          <mat-label>Amount</mat-label>
          <input matInput type="number" formControlName="amountR" (input)="onInput()">
          <mat-icon class="icon-rupee icon" matPrefix></mat-icon>
          <mat-error *ngIf="amountR.hasError('required') && amountR.touched">This field is required</mat-error>
          <mat-error *ngIf="amountR.hasError('min') && amountR.touched">The minimum reward amount is 100</mat-error>
        </mat-form-field>
        <div class="or"><span>or</span></div>
        <mat-form-field class="amount-input" appearance="standard">
          <input matInput placeholder="0" type="number" formControlName="amountD">
          <mat-icon class="icon-dollar icon" matPrefix></mat-icon>
          <mat-error *ngIf="amountD.hasError('required') && amountD.touched">This field is required</mat-error>
          <mat-error *ngIf="amountD.hasError('min') && amountD.touched">The minimum reward amount is 15</mat-error>
        </mat-form-field>
      </div><!-- Amount-ends -->
      <!-- Title-starts -->
      <app-input [inputType]="'text'"
                  [control]="title"
                  [group]="rewardForm"
                  [placeHolder]="info.reward_title.placeholder"
                  icon="icon-help"
                  [info]="info.reward_title.popover"
                  [errorMessage]="info.reward_title.error" >
      </app-input><!-- Title-starts -->
      <!-- Description-starts -->
      <mat-form-field class="input-container" appearance="fill">
        <mat-label>Reward Description</mat-label>
        <textarea matInput placeholder="Describe your Reward"
                  formControlName="desc"
                  id="desc"
                  maxlength="260">
        </textarea>
        <mat-hint align="end">{{desc.value?.length || 0}}/260</mat-hint>
        <mat-error *ngIf="desc.invalid && desc.touched">{{getErrorMessage(desc)}}</mat-error>
      </mat-form-field><!-- Description-ends -->
      <!-- Count-starts -->
      <div class="count-container">
        <div><span>No of Rewards Available</span></div>
        <mat-form-field class="count-input">
          <input matInput type="number" formControlName="rewardsCount">
          <mat-error *ngIf="rewardsCount.invalid && rewardsCount.touched">{{getErrorMessage(rewardsCount)}}</mat-error>
        </mat-form-field>
        <mat-checkbox color="primary" formControlName="isUnlimited" (change)="toggleCount()" >Unlimited</mat-checkbox>
      </div><!-- Count-starts -->
      <!-- Delivery Date-starts -->
      <app-datepicker placeHolder="Estimated Delivery"
                    [group]="rewardForm"
                    [control]="deliveryDate"
                    startView="year">
      </app-datepicker><!-- Delivery Date-starts -->
      <button type="submit" id="rewardFormId" style="display: none"></button>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="btn-container">
    <button mat-button color="primary" class="cancel-btn" (click)="closeDialog()">CANCEL</button>
    <button mat-raised-button class="save-btn" color="primary" (click)="save()" cdkFocusInitial>Save</button>
  </mat-dialog-actions>
</ng-template>

<!-- delete modal -->
<!-- rewards modal -->
<ng-template #deleteRewardModal>
  <mat-dialog-content>
    <div matDialogTitle class="dialog-title">Delete Reward</div>
    <p class="text-center">Are you really want to delete this reward?</p>
  </mat-dialog-content>

  <mat-dialog-actions class="btn-container">
    <button mat-button color="primary" class="cancel-btn" (click)="closeDialog()">CANCEL</button>
    <button mat-raised-button class="save-btn" color="warn" (click)="delete()" cdkFocusInitial>Delete</button>
  </mat-dialog-actions>
</ng-template>
